import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center bg-[#F1EFE7] rounded-full p-1 border border-[#E5E2D9] ${className}`} data-testid="lang-toggle">
      <button
        data-testid="lang-de"
        onClick={() => setLang("de")}
        className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${lang === "de" ? "bg-[#1A2F24] text-white" : "text-[#5C6B61] hover:text-[#1A2F24]"}`}
      >
        DE
      </button>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${lang === "en" ? "bg-[#1A2F24] text-white" : "text-[#5C6B61] hover:text-[#1A2F24]"}`}
      >
        EN
      </button>
    </div>
  );
}
